module.exports = __webpack_public_path__ + "img/pass_fail.b35f6981.png";